var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',_vm._b({staticClass:"label",class:{ up: _vm.moveToUp },on:{"click":function($event){return _vm.$emit('click')}}},'label',_vm.$attrs,false),[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }